import { validRoomId } from '../shared/rooms';

export function invitedRoomId(href: string): string | null {
  const id = new URL(href).searchParams.get('room');
  return validRoomId(id) ? id : null;
}

export function roomInviteUrl(href: string, roomId: string): string {
  if (!validRoomId(roomId)) throw new Error('房间链接无效');
  const url = new URL(href);
  url.hash = ''; url.searchParams.delete('playerId'); url.searchParams.delete('token');
  url.searchParams.set('room', roomId);
  return url.toString();
}
